import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualIcon from "../../../assets/aftersalesservice_icons/user_manual_icon.svg";
import DownloadWhite from "../../../assets/aftersalesservice_icons/download_white_icon.svg";
import Safety from "../../../assets/aftersalesservice_icons/safety_icon.png";
import QuickAccess from "../../../assets/aftersalesservice_icons/quick_access_icon.svg";
import Installation from "../../../assets/aftersalesservice_icons/installation_icon.png";
import Operating from "../../../assets/aftersalesservice_icons/operating_icon.png";
import Maintenance from "../../../assets/aftersalesservice_icons/maintenance_icon.png";
import FallbackImg from "../../../components/FallbackImg";
import ApiService from "../../../components/Api_services";
import { useLanguage } from "../LanguageContext";
import PreviewLayout from "./PreviewLayout";

const PreviewUserManual = () => {
  const { trans, lang } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get("item_id");
  const [userManualPdf, setUserManualPdf] = useState(null);

  useEffect(() => {
    const fetchUserManual = async () => {
      const apiLang = lang === "ch" ? "cn" : lang === "my" ? "ms" : lang;

      try {
        const response = await ApiService.getUserManual(itemId, apiLang, 1);
        if (response && response.status === 200) {
          setUserManualPdf(response.data[0]?.pdf_file);
        } else {
          console.error("Error fetching user manual:", response.message);
        }
      } catch (error) {
        console.error("Error fetching user manual:", error);
      }
    };

    fetchUserManual();
  }, [itemId, lang]);

  const openPdf = () => {
    window.open(userManualPdf, "_blank");
  };

  return (
    <PreviewLayout>
      <div className="as-user-manual-content" id="user_manual_modal">
        <div style={{ padding: "0 31.97px" }}>
          <div className="as-user-manual-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_back"
              onClick={() =>
                navigate(`/aftersalesservice/preview?item_id=${itemId}`)
              }
            >
              <FallbackImg src={BackBlue} alt="backblue" />
              {trans.back}
            </button>
            <div className="as-user-manual-main">
              <FallbackImg src={UserManualIcon} alt="usermanual" />
              <div>
                <div className="as-user-manual-main-title">
                  {trans.user_manual}
                </div>
                <div className="as-user-manual-main-text">
                  {trans.user_manual_sub}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="as-download-manual-btn"
              onClick={openPdf}
            >
              <FallbackImg src={DownloadWhite} alt="downloadwhite" />
              {trans.download_manual}
            </button>
          </div>

          <div className="as-quick-access-container">
            <div className="as-quick-access-title">{trans.sections}</div>

            <Link
              to={`/aftersalesservice/previewusermanualsections?item_id=${itemId}&user_manual_type=1`}
            >
              <div className="as-quick-access-box" id="user_manual_safety_btn">
                <div className="as-quick-access-text">
                  <FallbackImg src={Safety} alt="safety" />
                  <div>
                    <div>{trans.safety_instruct}</div>
                    <div className="as-quick-access-subtext">
                      {trans.safety_instruct_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/previewusermanualsections?item_id=${itemId}&user_manual_type=2`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_installation_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Installation} alt="installation" />
                  <div>
                    <div>{trans.install_guide}</div>
                    <div className="as-quick-access-subtext">
                      {trans.install_guide_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/previewusermanualsections?item_id=${itemId}&user_manual_type=3`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_operating_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Operating} alt="operating" />
                  <div>
                    <div>{trans.operate_instruct}</div>
                    <div className="as-quick-access-subtext">
                      {trans.operate_instruct_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>

            <Link
              to={`/aftersalesservice/previewusermanualsections?item_id=${itemId}&user_manual_type=4`}
            >
              <div
                className="as-quick-access-box"
                id="user_manual_maintenance_btn"
              >
                <div className="as-quick-access-text">
                  <FallbackImg src={Maintenance} alt="maintenance" />
                  <div>
                    <div>{trans.maint}</div>
                    <div className="as-quick-access-subtext">
                      {trans.maint_sub}
                    </div>
                  </div>
                </div>
                <div className="as-quick-access-btn">
                  <FallbackImg src={QuickAccess} alt="quickaccess" />
                </div>
              </div>
            </Link>
          </div>

          <div className="as-product-info-container">
            <div className="as-product-info-title">{trans.product_info}</div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.model_code}</div>
              <div id="model_code">--</div>
            </div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.aircon_type}</div>
              <div id="aircon_type">--</div>
            </div>
            <div className="as-product-info-input">
              <div style={{ color: "#525252" }}>{trans.horse_power}</div>
              <div id="horse_power">--</div>
            </div>
          </div>

          <div className="as-contact-support-container">
            <div className="as-contact-support-text">{trans.need_help}</div>
            <div className="as-contact-support-text">{trans.our_sup_2}</div>
            <button
              type="button"
              className="as-contact-support-btn"
              id="manual-contact-support-btn"
            >
              {trans.contact_sup}
            </button>
          </div>
        </div>
      </div>
    </PreviewLayout>
  );
};

export default PreviewUserManual;
